import type { AppManifest, EditorSDK, InnerRoutesSortOptionsStrings } from '@wix/platform-editor-sdk';
import type { TranslationFunction } from 'i18next';

import { MEMBERS_PAGES_PANEL_HELP_ID } from '../../../../constants';
import { getIsEditor3 } from '../../../../util';
import { getApplicationActions } from './app-actions';
import { getPageActions } from './page-actions';
import { getPageSettings } from './settings';
import { getPageSettingsEditor3 } from './settingsE3';

const sortInnerRoutes: InnerRoutesSortOptionsStrings = 'no-sort';

export const getPagesManifest = async (editorSDK: EditorSDK, t: TranslationFunction): Promise<AppManifest['pages']> => {
  const isEditor3 = getIsEditor3();
  return {
    sortInnerRoutes,
    pageDescriptors: {
      default: { icon: 'membersAction' },
    },
    applicationSettings: {
      default: {
        displayName: t('Pages_Panel_MemberMenu_Title'),
        helpId: MEMBERS_PAGES_PANEL_HELP_ID,
      },
    },
    applicationActions: await getApplicationActions(t),
    pageSettings: isEditor3 ? await getPageSettingsEditor3(editorSDK, t) : await getPageSettings(editorSDK, t),
    pageActions: await getPageActions(t),
  };
};
